export const config = {
  UUID: {
    header: 'UUID',
    key: 'uuidTag',
    label:'Ingrese un UUID-TAG'
  },
  NIP: {
    header: 'NIP',
    key: 'nip',
    label: 'Ingrese un NIP',
    label2: 'Confirma tu NIP'
  },
  BRAND: {
    header: 'Marca',
    key: 'brand',
    label: 'Ingresa una Marca'
  },
  STATUS: {
    header: 'Estado',
    key: 'status',
  },
  ACTIONS: {
    header: 'Acciones',
  }
};